// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/service/payment_service.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_proto_model_financial_payment } from "../model/financial/payment_pb";
import { file_proto_model_core_model_path } from "../model/core/model_path_pb";
import { file_proto_model_core_paging } from "../model/core/paging_pb";

/**
 * Describes the file proto/service/payment_service.proto.
 */
export const file_proto_service_payment_service = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_proto_model_financial_payment, file_proto_model_core_model_path, file_proto_model_core_paging]);

/**
 * Describes the message carmen.CreatePaymentRequest.
 * Use `create(CreatePaymentRequestSchema)` to create a new message.
 */
export const CreatePaymentRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 0);

/**
 * Describes the message carmen.CreatePaymentResponse.
 * Use `create(CreatePaymentResponseSchema)` to create a new message.
 */
export const CreatePaymentResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 1);

/**
 * Describes the message carmen.GetPaymentRequest.
 * Use `create(GetPaymentRequestSchema)` to create a new message.
 */
export const GetPaymentRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 2);

/**
 * Describes the message carmen.GetPaymentResponse.
 * Use `create(GetPaymentResponseSchema)` to create a new message.
 */
export const GetPaymentResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 3);

/**
 * Describes the message carmen.ListPaymentsRequest.
 * Use `create(ListPaymentsRequestSchema)` to create a new message.
 */
export const ListPaymentsRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 4);

/**
 * Describes the message carmen.ListPaymentsResponse.
 * Use `create(ListPaymentsResponseSchema)` to create a new message.
 */
export const ListPaymentsResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 5);

/**
 * Describes the message carmen.ConfirmPaymentRequest.
 * Use `create(ConfirmPaymentRequestSchema)` to create a new message.
 */
export const ConfirmPaymentRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 6);

/**
 * Describes the message carmen.ConfirmPaymentResponse.
 * Use `create(ConfirmPaymentResponseSchema)` to create a new message.
 */
export const ConfirmPaymentResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 7);

/**
 * Describes the message carmen.CancelPaymentRequest.
 * Use `create(CancelPaymentRequestSchema)` to create a new message.
 */
export const CancelPaymentRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 8);

/**
 * Describes the message carmen.CancelPaymentResponse.
 * Use `create(CancelPaymentResponseSchema)` to create a new message.
 */
export const CancelPaymentResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 9);

/**
 * Describes the message carmen.CreatePaymentMethodRequest.
 * Use `create(CreatePaymentMethodRequestSchema)` to create a new message.
 */
export const CreatePaymentMethodRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 10);

/**
 * Describes the message carmen.CreatePaymentMethodResponse.
 * Use `create(CreatePaymentMethodResponseSchema)` to create a new message.
 */
export const CreatePaymentMethodResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 11);

/**
 * Describes the message carmen.GetPaymentMethodRequest.
 * Use `create(GetPaymentMethodRequestSchema)` to create a new message.
 */
export const GetPaymentMethodRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 12);

/**
 * Describes the message carmen.GetPaymentMethodResponse.
 * Use `create(GetPaymentMethodResponseSchema)` to create a new message.
 */
export const GetPaymentMethodResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 13);

/**
 * Describes the message carmen.ListPaymentMethodsRequest.
 * Use `create(ListPaymentMethodsRequestSchema)` to create a new message.
 */
export const ListPaymentMethodsRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 14);

/**
 * Describes the message carmen.ListPaymentMethodsResponse.
 * Use `create(ListPaymentMethodsResponseSchema)` to create a new message.
 */
export const ListPaymentMethodsResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 15);

/**
 * Describes the message carmen.DeletePaymentMethodRequest.
 * Use `create(DeletePaymentMethodRequestSchema)` to create a new message.
 */
export const DeletePaymentMethodRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 16);

/**
 * Describes the message carmen.HandleWebhookRequest.
 * Use `create(HandleWebhookRequestSchema)` to create a new message.
 */
export const HandleWebhookRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 17);

/**
 * Describes the message carmen.HandleWebhookResponse.
 * Use `create(HandleWebhookResponseSchema)` to create a new message.
 */
export const HandleWebhookResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 18);

/**
 * Describes the message carmen.GetPaymentByIdempotencyKeyRequest.
 * Use `create(GetPaymentByIdempotencyKeyRequestSchema)` to create a new message.
 */
export const GetPaymentByIdempotencyKeyRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 19);

/**
 * Describes the message carmen.GetPaymentByIdempotencyKeyResponse.
 * Use `create(GetPaymentByIdempotencyKeyResponseSchema)` to create a new message.
 */
export const GetPaymentByIdempotencyKeyResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 20);

/**
 * Describes the message carmen.CreatePaymentWithBookingLinkRequest.
 * Use `create(CreatePaymentWithBookingLinkRequestSchema)` to create a new message.
 */
export const CreatePaymentWithBookingLinkRequestSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 21);

/**
 * Describes the message carmen.CreatePaymentWithBookingLinkResponse.
 * Use `create(CreatePaymentWithBookingLinkResponseSchema)` to create a new message.
 */
export const CreatePaymentWithBookingLinkResponseSchema = /*@__PURE__*/
  messageDesc(file_proto_service_payment_service, 22);

/**
 * PaymentService handles payment operations
 *
 * @generated from service carmen.PaymentService
 */
export const PaymentService = /*@__PURE__*/
  serviceDesc(file_proto_service_payment_service, 0);

